export { useAnalytics } from './use-analytics'
export const withNavigationAnalytics = (v: any) => v

// TODO move this to a betting feature lib
export const useBettingAnalytics = () => ({
  betTrackingFn: () => {},
  betCartTrackingFn: () => {},
})
